export default (classes) => {
  const mapping = classes.reduce((agg, cls) => {
    const keys = cls.categories.length ? cls.categories : ["Uncategorized"]
    keys.forEach((key) => {
      agg[key] = [...(agg[key] || []), cls]
    })
    return agg
  }, {})

  return Object.keys(mapping)
    .sort()
    .reduce(
      (agg, next) => ({
        ...agg,
        [next]: mapping[next],
      }),
      {},
    )
}
